// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__i+dkR","headingWrapper":"styles_headingWrapper__+WjTN","heading":"styles_heading__IrGbS"};